var _rect, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "btn/up"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6287 16.0178L11.3002 19.3462C10.3239 20.3225 8.74101 20.3225 7.7647 19.3462C6.78839 18.3699 6.78839 16.787 7.7647 15.8107L12.7144 10.8609C13.2399 10.3355 13.941 10.0929 14.6287 10.133C15.3164 10.0929 16.0175 10.3355 16.5429 10.8609L21.4926 15.8107C22.4689 16.787 22.4689 18.3699 21.4926 19.3462C20.5163 20.3225 18.9334 20.3225 17.9571 19.3462L14.6287 16.0178Z",
    fill: "#E37B3C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_4023",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 10,
    width: 16,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "<_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6287 16.0178L11.3002 19.3462C10.3239 20.3225 8.74101 20.3225 7.7647 19.3462C6.78839 18.3699 6.78839 16.787 7.7647 15.8107L12.7144 10.8609C13.2399 10.3355 13.941 10.0929 14.6287 10.133C15.3164 10.0929 16.0175 10.3355 16.5429 10.8609L21.4926 15.8107C22.4689 16.787 22.4689 18.3699 21.4926 19.3462C20.5163 20.3225 18.9334 20.3225 17.9571 19.3462L14.6287 16.0178Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_4023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/accent/orange/base"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 7",
    width: 30,
    height: 30,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.c693579c04767d97361df5a90fbcb167.svg";
export { ForwardRef as ReactComponent };